const globalToastOptions = Object.freeze({
  title: "Atención",
  static: false,
  solid: true,
});

class Messages {
  constructor(vm, options) {
    this.vm = vm;
    this.options = options;
  }

  toast(text, options) {
    options = Object.assign(options || {}, globalToastOptions);
    this.vm.$root.$bvToast.toast(text, options);
  }

  success(text, options) {
    options = Object.assign(options || {}, { variant: "success" });
    this.toast(text, options);
  }

  info(text, options) {
    options = Object.assign(options || {}, { variant: "info" });
    this.toast(text, options);
  }

  warning(text, options) {
    options = Object.assign(options || {}, { variant: "warning" });
    this.toast(text, options);
  }

  danger(text, options) {
    options = Object.assign(options || {}, { variant: "danger" });
    this.toast(text, options);
  }

  confirm(text, options) {
    let defaultOptions = {
      title: "Confirmación requerida",
      size: "md",
      buttonSize: "md",
      okVariant: "primary",
      headerClass: "p-2 border-bottom-0",
      footerClass: "p-2 border-top-0",
      centered: true,
    };
    options = Object.assign(defaultOptions, options || {});
    return this.vm.$root.$bvModal.msgBoxConfirm(text, options);
  }

  alert(text, type, options) {
    let defaultOptions = {
      title: "Atención",
      size: "md",
      buttonSize: "md",
      okVariant: type || "warning",
      headerClass: "p-2 border-bottom-0",
      footerClass: "p-2 border-top-0",
      centered: true,
    };
    options = Object.assign(defaultOptions, options || {});
    return this.vm.$root.$bvModal.msgBoxOk(text, options);
  }
}

export default {
  install(Vue, options) {
    Object.defineProperty(Vue.prototype, "$messages", {
      get() {
        return new Messages(this, options);
      },
    });
  },
};
